<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container" (keydown)="keyDownFunction($event)">
    <div class="row">
        <div class="col-24">
            <h1 class="medium">Section 4: Coordination of Benefits</h1>
        </div>
    </div>

    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="hasError">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages"><button>{{error}}</button></li>
                </ul>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-16">
            <p class="required">All fields are required, unless marked as optional.</p>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <fieldset class="radio">
                <legend class="blue-text">{{spnDoDoes}} {{spnIsBeneficiary}} have prescription drug coverage other than Medicare, such as:<br /><br /> Private insurance, TRICARE, Federal Employee Health Benefits Coverage, VA benefits or State Pharmaceutical Assistance Programs?</legend>
                <ValidatedRadioButtonGroup [options]="rblSecondaryCoverage"
                                           [radioGroupName]="'rblSecondaryCoverage'"
                                           [selectedValue]="enrollmentViewModel.OTHCVRG"
                                           (onValueChange)="ShowCoverageInfo($event)">
                </ValidatedRadioButtonGroup>
            </fieldset>
        </div>
    </div>

    <div *ngIf="IsCovergInfoYes">
        <div class="row">
            <div class="col-16">
                <p class="blue-text">
                    Can you please provide me with the following information from {{spnIsBeneficiaryYour}} ID card for your other coverage?
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Name of other coverage'"
                                        [text]="enrollmentViewModel.OTHCVRGNAME"
                                        [validators]="[]"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollmentViewModel.OTHCVRGNAME = $event">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <label>Termination Date of other coverage (optional)</label>
                    <JQDatePicker [selectedDate]="enrollmentViewModel.COBTERMDT"
                                  (elementClicked)="enrollmentViewModel.COBTERMDT = $event">
                    </JQDatePicker>
                    <!--<ValidatedDateTextField label="Termination Date for this coverage"
                                            [date]="enrollmentViewModel.COBTERMDT"
                                            (onDateChange)="enrollmentViewModel.COBTERMDT = $event"
                                            [validators]="[dateTextFieldValidator]"
                                            [disabled]="disabled">
                    </ValidatedDateTextField>-->
                </div>

            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'ID# for this coverage (optional)'"
                                        [text]="enrollmentViewModel.OTHCVRGID"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollmentViewModel.OTHCVRGID = $event">

                    </ValidatedTextField>
                </div>

            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Group # for this coverage (optional)'"
                                        [text]="enrollmentViewModel.OTHCVRGGRP"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollmentViewModel.OTHCVRGGRP = $event">

                    </ValidatedTextField>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'BIN of other coverage (optional)'"
                                        [text]="enrollmentViewModel.COBBIN"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollmentViewModel.COBBIN = $event">

                    </ValidatedTextField>
                </div>

            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'PCN of other coverage (optional)'"
                                        [text]="enrollmentViewModel.COBPCN"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollmentViewModel.COBPCN = $event">

                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper bottom-10">
                    <label>Effective Date of other coverage (optional)</label>
                    <JQDatePicker [selectedDate]="enrollmentViewModel.COBEFFDT"
                                  (elementClicked)="enrollmentViewModel.COBEFFDT = $event">
                    </JQDatePicker>
                    <!--<ValidatedDateTextField label="Effective Date for this coverage"
                                            [date]="enrollmentViewModel.COBEFFDT"
                                            (onDateChange)="enrollmentViewModel.COBEFFDT = $event"
                                            [validators]="[dateTextFieldValidator]"
                                            [disabled]="disabled">
                    </ValidatedDateTextField>-->
                </div>

            </div>
        </div>
    </div>
    <div class="row" style="clear:left;display:flex;">
        <div class="col-16">
            <fieldset class="radio">
                <legend class="blue-text">Is the permanent address that was provided, for a long term care facility, such as a nursing home or assisted living facility?</legend>
                <ValidatedRadioButtonGroup [options]="rbllongTerm"
                                           [selectedValue]="enrollmentViewModel.RBLLONGTERM"
                                           [radioGroupName]="'rbllongTerm'"
                                           (onValueChange)="ShowrbllongtermOptions($event)">
                </ValidatedRadioButtonGroup>
            </fieldset>
        </div>
    </div>
    <fieldset class="radio" *ngIf="IsRbllongtermYes">
        <legend class="blue-text bottom-10 limit-width">May I please have the institution name and phone number?</legend>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField label="Institution Name"
                                        [maxlength]="50"
                                        [text]="enrollmentViewModel.LTCFACILITY"
                                        (onValueChange)="enrollmentViewModel.LTCFACILITY= $event"
                                        [disabled]="disabled">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField label="Phone Number (numbers only)"
                                        [maxlength]="10"
                                        [text]="enrollmentViewModel.LTCPHONE"
                                        (onValueChange)="enrollmentViewModel.LTCPHONE= $event"
                                        [validators]="[]"
                                        [disabled]="disabled">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
    </fieldset>
    <div>
        <div class="row" style="clear:none;">
            <div class="col-16">
                <fieldset class="radio">
                    <legend class="blue-text" *ngIf="ShowCurrentYearScript">
                        Plan information is available for free in other languages. <br />
                        Would {{spnyouthey}} like to receive written communication and plan documents from Aetna in a language other than English?
                        <br /><br />What is the language preference?
                    </legend>
                    <legend class="blue-text" *ngIf="!ShowCurrentYearScript">
                        Plan information is available for free in other languages and accessible formats. You can access the summary of benefits that includes additional benefit information as well as the Stars Ratings documents online at <a class="link" href="https://www.aetnamedicare.com" target="_blank">AetnaMedicare.com</a>. Every year, Medicare evaluates plans based on 5-Star rating system. <br />
                        Would {{spnyouthey}} like to receive written communication and plan documents from Aetna in a language other than English?
                        <br /><br />What is the language preference?
                    </legend>
                    <ValidatedRadioButtonGroup [selectedValue]="enrollmentViewModel.LANG"
                                               [options]="rblLanguage"
                                               [radioGroupName]="'rblLanguage'"
                                               (onValueChange)="enrollmentViewModel.LANG = $event">
                    </ValidatedRadioButtonGroup>
                    <br />
                    <legend class="blue-text">
                        Would {{spnyouthey}} like information in an accessible format?<br />
                    </legend>
                    <ValidatedRadioButtonGroup [options]="optionaccessibility"
                                               [selectedValue]="accessibilityValue"
                                               (onValueChange)="onAccessibilityChanges($event)"
                                               [radioGroupName]="'Langformat'">
                    </ValidatedRadioButtonGroup>
                    <legend class="blue-text">
                        Call us at 1-855-338-7027 (TTY: 711) if you need information in another language or format. We’re here 24 hours a day, 7 days a week.
                    </legend>
                </fieldset>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <fieldset class="radio">
                    <legend class="blue-text" *ngIf="ShowCurrentYearScript">
                        Would you like to receive paperless Explanation of Benefit (EOB) statements?
                        We’ll send you a monthly email letting you know how to access and view your secure EOB statement. You will need to provide us with your email address.  You can opt out at any time.

                    </legend>
                    <div class="blue-text" *ngIf="!ShowCurrentYearScript">
                        Would you like to receive paperless Explanation of Benefit (EOB) statements?
                        We’ll send you a monthly email letting you know how to access and view your secure EOB statement. You will need to provide us with your email address.  You can opt out at any time.

                    </div>
                    <div class="bottom-20">
                        <ValidatedCheckbox [id]="'EOBoption'"
                                           [label]="'Yes, I want to receive my EOB statements electronically.'"
                                           [checked]="IsEobYes"
                                           (onValueChange)="ShowEobEmail($event)">
                        </ValidatedCheckbox>
                    </div>
                </fieldset>
            </div>
        </div>
        <div *ngIf="IsEobYes">
            <div class="row">
                <div class="col-8">
                    <p class="qtip-note" *ngIf="isQtip"><strong>qTip Note:</strong> May I please have your email address?</p>
                    <div class="input-wrapper">
                        <ValidatedTextField class="" [maxlength]="40"
                                            [label]="'Email Address'"
                                            id="EmailAddress"
                                            [text]="enrollmentViewModel.APPEMAIL"
                                            (onValueChange)="enrollmentViewModel.APPEMAIL = $event">

                        </ValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <div class="bottom-20">
                        <p>
                            We will use your email address to keep you up to date on your SilverScript plan.
                            You can opt out any time.
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <p class="blue-text" *ngIf="ShowCurrentYearScript">
                        Visit the online preference center at <a class="link" href="https://www.aetnamedicare.com" target="_blank">www.aetnamedicare.com</a> once you complete {{spnyourtheir}}  registration by clicking Login and following the steps for register. See exactly what’s available for {{spnyouthem}} to receive digitally and manage {{spnyourtheir}} document delivery preferences between digital and mailed. {{spnyouthey | titlecase}} may go back to paper at any time.
                        Please note that some documents may take up to two months to switch to digital delivery. Thank you for going paperless!
                    </p>
                    <p class="blue-text" *ngIf="!ShowCurrentYearScript">
                        Visit the online preference center at <a class="link" href="https://www.aetnamedicare.com" target="_blank">www.aetnamedicare.com</a> once you complete {{spnyourtheir}}  registration by clicking Login and following the steps for register. See exactly what’s available for {{spnyouthem}} to receive digitally and manage {{spnyourtheir}} document delivery preferences between digital and mailed. {{spnyouthey | titlecase}} may go back to paper at any time.
                        Please note that some documents may take up to two months to switch to digital delivery. Thank you for going paperless!
                    </p>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="IsEobNo">
            <div class="col-16">
                <p class="blue-text">
                    {{spntheenrolleeYou}} proposed effective date of coverage is {{effectiveDate}}.
                </p>
            </div>
        </div>
        <div class="row" style="clear: left; display:flex">
            <div class="col-16">
                <fieldset class="radio">
                    <legend class="blue-text">{{spnIsAreCapt}} {{spnYoutheenrollee1}} currently a member of a Medicare Advantage Plan, such as an HMO or PPO?</legend>
                    <ValidatedRadioButtonGroup [options]="rdlHMO"
                                               [selectedValue]="enrollmentViewModel.RBLHMO"
                                               (onValueChange)="ShowOptionsHMO($event)"
                                               [radioGroupName]="'rdlHMO'">
                    </ValidatedRadioButtonGroup>
                </fieldset>
            </div>
        </div>
        <div class="row" *ngIf="IsRdlHMOYes">
            <div class="col-16">
                <p class="blue-text" *ngIf="ShowCurrentYearScript">If {{spnIsBeneficiary}} {{spnIsAre}} a member of a Medicare Advantage Plan, such as an HMO or PPO plan, {{spnyouthey}} may already have prescription drug coverage from your Medicare Advantage Plan.</p>
                <p class="blue-text" *ngIf="!ShowCurrentYearScript">If {{spnIsBeneficiary}} {{spnIsAre}} a member of a Medicare Advantage Plan, such as an HMO or PPO plan, {{spnyouthey}} may already have prescription drug coverage from your Medicare Advantage Plan.</p>
                <p class="blue-text bottom-20" *ngIf="ShowCurrentYearScript">By enrolling in Aetna, {{spnYourenrollee}} Medicare Advantage Plan membership may end. This will affect {{spnyourhisher}} doctor and hospital coverage as well as your prescription drug coverage. Please read the information that {{spnyourhisher}} plan sends you.  If {{spnIsBeneficiaryYou}} {{spnHasHave}} questions, contact the plan provider.</p>
                <p class="blue-text bottom-20" *ngIf="!ShowCurrentYearScript">By enrolling in Aetna, {{spnYourenrollee}} Medicare Advantage Plan membership may end. This will affect {{spnyourtheir}} doctor and hospital coverage as well as your prescription drug coverage. Please read the information that {{spnyourtheir}} plan sends you.  If {{spnIsBeneficiaryYou}} {{spnHasHave}} questions, contact the plan provider.</p>
            </div>
        </div>
        <div class="row" style="clear:left;display:flex;">
            <div class="col-16">
                <fieldset class="radio">
                    <legend class="blue-text" *ngIf="ShowCurrentYearScript">Will {{spnIsBeneficiaryYou}} have health coverage from an employer or union during the same time you are looking for coverage from Aetna?</legend>
                    <legend class="blue-text" *ngIf="!ShowCurrentYearScript">Will {{spnIsBeneficiaryYou}} have health coverage from an employer or union during the same time you are looking for coverage from Aetna?</legend>
                    <ValidatedRadioButtonGroup [options]="rblRep"
                                               [selectedValue]="enrollmentViewModel.RBLHEALTHCOVERAGE"
                                               (onValueChange)="ShowGroupOptionsHEALTHCOVERAGE($event)"
                                               [radioGroupName]="'rblRep'">
                    </ValidatedRadioButtonGroup>
                </fieldset>
            </div>
        </div>
        <div class="row" *ngIf="IsRblRepYes" style="clear:left;">
            <div class="col-16">
                <p class="blue-text bottom-20">
                    If you currently have health coverage from an employer or union, joining {{planName}} could affect your employer or union health beneﬁts. You could lose your employer or union health coverage if you join {{planName}}. <span class="normalFont"> Read the communications your employer or union sends you. If you have questions, visit their website, or contact the office listed in their communications. If there isn’t information on whom to contact, your benefits administrator or the office that answers questions about your coverage can help.</span>
                </p>
                <p class="blue-text bottom-20">Do you still want to proceed?</p>
                <ValidatedRadioButtonGroup [options]="rblStillProceed"
                                           [selectedValue]="enrollmentViewModel.RBLLIS"
                                           (onValueChange)="ShowOptionsStillProceed($event)"
                                           [radioGroupName]="'rblStillProceed'">
                </ValidatedRadioButtonGroup>
            </div>
            <div class="col-16" *ngIf="IsProceedNo">
                <p class="blue-text bottom-20">We can stop the enrollment and you can check with your employer about how this will impact your plan. You can call us back if you want to finish the enrollment.</p>
                <p class="qtip-note" *ngIf="isQtip"><strong>qTip Note:</strong> Proceed to <u>“Section 7. Enrollment End”</u>. <a (click)="SalesBenfDetails()" class="link">Click here</a></p>
            </div>
        </div>
    </div>

    <div id="divValidPeriodNo" [hidden]="!IsRblvalidPeriodNo">
        <div class="row">
            <div class="col-16">
                <p class="blue-text">
                    Unfortunately, {{spnYoutheenrollee}} {{spnIsAre}} not eligible to join SilverScript as there is no valid enrollment period available. I will not be able to take an enrollment for {{spnYoutheenrollee}} in SilverScript at this time. Please call back when your enrollment period becomes valid.
                </p>
            </div>
        </div>
        <div class="row" *ngIf="isQtip">
            <div class="col-16">
                <p class="qtip-note"><strong>qTip Note:</strong> Answer questions as applicable, then proceed to <u>“Section 6. Enrollment End”</u>. Disposition as Ineligible – Invalid Enrollment Period. <a (click)="SalesBenfDetails()"><strong> Click here</strong></a></p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary" *ngIf="showsubmit" (click)="formSubmit()">Continue</button>
            <button class="button cancel" (click)="onBack()">Back</button>
        </div>
    </div>
</div>
